module.exports = "/_next/static/images/know-transfez-fund-b0b9fb1e89c425b4bd5b5498a94e3193.svg";